export default {

    buildUrl(endpoint, params) {
        console.log(params);
        if(!params) {
            params = {};
        }

        Object.entries(params).forEach((param, ind) => {
            if (ind === 0) {
                endpoint += '?' + param.join('=');
            } else {
                endpoint += '&' + param.join('=');
            }
        });

        return endpoint;
    },

    validateEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    },

    getErrorMessages(errors, key) {
        return Object.keys(errors)
            .filter(k => k.startsWith(key))
            .map(k => errors[k])
            .reduce((acc, val) => acc.concat(val), []);
    }

}
